import React from "react";
import classNames from "classnames";
import {SectionTilesProps} from "../../utils/SectionProps";

import { withTranslation } from "react-i18next";

import Image from "../elements/Image";
import Button from '../elements/Button';

const propTypes = {
  ...SectionTilesProps.types
};

const defaultProps = {
  ...SectionTilesProps.defaults
};

const Pricing = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    "testimonial section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames("tiles-wrap", pushLeft && "push-left");

  const content = {
    title: "Transform your business now, use EcomSpy.",
    paragraph:"",
    pack : {
        header : 'Exclusive Launch offer',
        title : 'EcomSpy Premium',
        items : [
          {text : 'Immediate access to the application'},
          {text : 'Access to our best influencers analysis tool'},
          {text : 'Immediate access to thousands of influencers and e-shops analyzed and tracked in real time.'},
          {text : 'Access to trendy products'},
          {text : 'Get insights about your comepitition and spy their strategies'},
        ],
        button : "",
      }
  }

  const t = props.t;

  return (
    <section  className={outerClasses} style={{paddingBottom:'100px'}}>
      <div className="container">
        <div className={innerClasses}>
          <div className={tilesClasses} id={props.id}>
            <div className="tiles-item reveal-from-bottom">
                <div className="tiles-item-inner" >
                  <div className="">
                    <div className="center-content">
                      <div
                        className=""
                        style={{width:'80%', color:'#fff',  padding:'8px', margin:'0 auto', background:'#1CB68B'}}
                      >
                        {t(content.pack.header)}
                      </div>
                      <h2 className="center-content">{t(content.pack.title)}</h2>

                      <ul className="" style={{textAlign : 'left', fontSize:'16px'}}>
                        {
                          content.pack.items.map((item, index) => (
                            <li key={index}>
                              {t(item.text)}
                            </li>
                          ))
                        }
                      </ul>

                      <div className="center-content" style={{marginBottom:'10px'}}>
                        <h1 className="mb-0">
                          <span className="">39€</span>
                        </h1>
                        <span className="mb-5" style={{fontSize:'10px'}}>{t('TTC / Month')}</span>
                      </div>

                      <Button tag="a" color="primary" wideMobile target='_blank' href="https://app.ecomspy.io/" style={{width:'80%'}}>
                        {t('Access to EcomSpy')}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

          </div>
        </div>

        <h2 className="center-content">
          {content.title}
        </h2>
        <div
          data-reveal-delay="200"
          className="tiles-item reveal-from-bottom center-content"
          style={{margin: "0 auto", marginBottom: "30px"}}
        >
          <Image
            src={require("./../../assets/images/pricing.png")}
            alt="pricing"
          />
        </div>

      </div>
    </section>
  );
};

Pricing.propTypes = propTypes;
Pricing.defaultProps = defaultProps;

export default withTranslation()(Pricing);
